import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

const FIELDS = [["phone", "Phone"], ["whatsapp", "WhatsApp"], ["email", "Email"], ["instagram", "Instagram @handle"], ["linkedin", "LinkedIn profile link"], ["tiktok", "TikTok @handle"]];
export const swapUrl = (token) => `${window.location.origin}/swap/${token}`;

const useSwapToken = () => {
  const [t, setT] = useState(null);
  useEffect(() => {
    // Codes expire after 15 minutes; refresh well before that while the screen is open
    let live = true;
    const load = () => api.swapToken().then((r) => live && setT(r.token), () => null);
    load();
    const id = setInterval(load, 10 * 60 * 1000);
    return () => { live = false; clearInterval(id); };
  }, []);
  return t;
};

const CardFields = ({ card }) => {
  const qc = useQueryClient();
  const [v, setV] = useState(card.values);
  const save = (next) => api.saveCard(next).then((c) => qc.setQueryData(["card"], c), () => toast.error("Couldn't save"));
  const field = (k) => ({ value: v[k] || "", onChange: (e) => setV({ ...v, [k]: e.target.value }), onBlur: () => save({ ...v, share: card.share }) });
  return (
    <ul className="space-y-2" data-testid="swap-card-fields">
      {FIELDS.map(([k, label]) => (
        <li key={k} className="flex items-center gap-2">
          <Switch checked={!!card.share[k]} onCheckedChange={(on) => save({ ...v, share: { ...card.share, [k]: on } })} aria-label={`Share ${label}`} data-testid={`swap-share-${k}`} />
          <Input placeholder={label} {...field(k)} className="h-9" data-testid={`swap-field-${k}`} />
        </li>
      ))}
    </ul>
  );
};

export const MyCode = () => {
  const token = useSwapToken();
  const { data: card } = useQuery({ queryKey: ["card"], queryFn: api.card });
  return (
    <div className="space-y-4" data-testid="swap-my-code">
      <div className="mx-auto w-fit rounded-2xl bg-white p-4" data-testid="swap-qr">
        {token ? <QRCodeSVG value={swapUrl(token)} size={208} level="M" /> : <div className="w-[208px] h-[208px] animate-pulse bg-slate-200 rounded" />}
      </div>
      <p className="text-center text-sm text-slate-300">Let them scan this with their phone camera — you'll be friends instantly and they can save your details to their contacts.</p>
      {card && <CardFields card={card} />}
      <p className="text-[11px] text-slate-500">Only the details switched on are shared, and only with people who scan this code. The code changes every few minutes.</p>
    </div>
  );
};
